import { TableRow, TableCell, Typography } from '@sanlam-glacier/app-common/components';
import { useNavigate } from 'react-router-dom';
import { StageStatus } from '../../molecules/stage-status/StageAndStatus';
import { formatDateAsString } from 'utils/string-handling/human-readable-text';
import { CaseType } from 'modules/case-tracking/types/case-tracking.types';

type CaseTrackingRowProps = {
  row: CaseType;
};

export const CaseTrackingTableRow = ({ row }: CaseTrackingRowProps) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`instruction/${row.instructionNumber}`);
  };

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
  };

  return (
    <TableRow key={row.id} onClick={handleRowClick} style={{ cursor: 'pointer' }}>
      <TableCell align={TableCell.ALIGN.LEFT} size={TableCell.SIZE.SMALL}>
        <Typography
          data-testid={'created' + row.id}
          weight={Typography.WEIGHT.NORMAL}
          variant={Typography.VARIANT.B4}
        >
          {formatDateAsString(new Date(row.created)) ?? '-'}
        </Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.LEFT} size={TableCell.SIZE.SMALL}>
        <Typography
          data-testid={'instructionNumber' + row.id}
          color={Typography.COLOR.PRIMARY}
          weight={Typography.WEIGHT.NORMAL}
          variant={Typography.VARIANT.B4}
        >
          {row.instructionNumber ?? '-'}
        </Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.LEFT}>
        <Typography
          data-testid={'clientName' + row.id}
          weight={Typography.WEIGHT.MEDIUM}
          variant={Typography.VARIANT.B4}
        >
          {truncateText(row.clientName, 20) ?? '-'}
        </Typography>
        <Typography
          data-testid={'clientId' + row.id}
          weight={Typography.WEIGHT.NORMAL}
          variant={Typography.VARIANT.B4}
        >
          {row.clientId ?? '-'}
        </Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.LEFT} size={TableCell.SIZE.LARGE}>
        <Typography
          data-testid={'instructionType' + row.id}
          title={row.instructionType}
          weight={Typography.WEIGHT.MEDIUM}
          variant={Typography.VARIANT.B4}
        >
          {truncateText(row.instructionType, 20) ?? '-'}
        </Typography>
        <Typography
          data-testid={'instructionCategory' + row.id}
          weight={Typography.WEIGHT.NORMAL}
          variant={Typography.VARIANT.B4}
        >
          {row.instructionCategory ?? '-'}
        </Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.LEFT} size={TableCell.SIZE.SMALL}>
        <Typography
          data-testid={'proposalNumber' + row.id}
          weight={Typography.WEIGHT.NORMAL}
          variant={Typography.VARIANT.B4}
        >
          {row.proposalNumber ?? '-'}
        </Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.LEFT} size={TableCell.SIZE.SMALL}>
        <Typography
          data-testid={'investmentNumber' + row.id}
          weight={Typography.WEIGHT.NORMAL}
          variant={Typography.VARIANT.B4}
        >
          {row.investmentNumber ?? '-'}
        </Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.LEFT} size={TableCell.SIZE.LARGE}>
        <StageStatus
          data-testid={'stageAndStatus' + row.id}
          stage={row.stage}
          stageDescription={truncateText(row.status, 25)}
          isCancelled={row.isCancelled}
          isTablet={false}
          isProgressVersion={false}
        />
      </TableCell>
      <TableCell align={TableCell.ALIGN.LEFT} size={TableCell.SIZE.SMALL}>
        <Typography
          data-testid={'lastModified' + row.id}
          weight={Typography.WEIGHT.NORMAL}
          variant={Typography.VARIANT.B4}
        >
          {formatDateAsString(new Date(row.lastModified)) ?? '-'}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
